export enum RecoverTypeEnum {
  NEGOTIATION = 1,
  QUOTATION = 2,
}
